import ContractsTable from "@/components/financiacion/ContractsTable";

const Prestamos = () => <ContractsTable kind="loan" />;

export default Prestamos;
